import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export function LoadingState({
  label = "Loading…",
  className,
  rows = 0,
}: {
  label?: string;
  className?: string;
  rows?: number;
}) {
  if (rows > 0) {
    return (
      <div className={cn("space-y-2", className)} aria-busy="true" aria-live="polite">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="h-10 rounded-md bg-muted/60 animate-pulse" />
        ))}
        <span className="sr-only">{label}</span>
      </div>
    );
  }
  return (
    <div
      className={cn("flex items-center justify-center gap-2 py-12 text-muted-foreground", className)}
      aria-busy="true"
      aria-live="polite"
    >
      <Loader2 className="h-4 w-4 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
